import React from 'react';
import { normalizeDestination } from '../../utils/destinations';
import questionnaire from '../../config/questionnaire';

const CompanySubmissionHistory = ({ submissions, onEdit, editingSubmissionId }) => {
  if (submissions.length === 0) {
    return (
      <div className="rounded-xl border border-slate-200/70 bg-white shadow-sm p-6 xl:sticky xl:top-6">
        <p className="text-xs uppercase text-slate-400">Historial</p>
        <h2 className="text-2xl font-semibold text-slate-900 mb-2">Aún sin envíos</h2>
        <p className="text-slate-600">Cuando completes tu primer cuestionario verás el detalle en esta tarjeta.</p>
      </div>
    );
  }

  const statusStyles = {
    approved: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    rejected: 'bg-rose-100 text-rose-700 border-rose-200',
    pending: 'bg-amber-100 text-amber-700 border-amber-200',
  };

  return (
    <div className="rounded-xl border border-slate-200/70 bg-white shadow-sm p-6 space-y-4 max-h-[650px] overflow-y-auto xl:sticky xl:top-6">
      <div>
        <p className="text-xs uppercase text-slate-400">Historial</p>
        <h2 className="text-2xl font-semibold text-slate-900">Evolución de envíos</h2>
      </div>
      {submissions.map((sub) => (
        <div key={sub.docId} className="rounded-xl border border-slate-100 bg-white p-4 space-y-3 shadow-sm">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs uppercase text-slate-400">Periodo</p>
              <p className="text-lg font-semibold text-slate-900">{sub.month}</p>
            </div>
            <div className="flex flex-wrap justify-end gap-1.5">
              <span className={`px-3 py-1 rounded-full text-xs font-semibold ${statusStyles[sub.status] || 'bg-slate-100 text-slate-600'}`}>
                {sub.status === 'approved' ? 'Aprobado' : sub.status === 'rejected' ? 'Observado' : 'En revisión'}
              </span>
              {sub.excludedFromResults && (
                <span className="px-3 py-1 rounded-full bg-slate-100 text-xs font-semibold text-slate-600">
                  Excluido
                </span>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3 text-sm text-slate-600">
            <p>Destino: <span className="font-semibold text-slate-900">{normalizeDestination(sub.destination)}</span></p>
            <p>Costo / tendencia: <span className="font-semibold text-slate-900">{sub.trend || 'No reportado'}</span></p>
            <p>Rentabilidad: <span className="font-semibold text-slate-900">{sub.rentabilidadTrend || 'Sin dato'}</span></p>
            <p>Enviado el: <span className="font-semibold text-slate-900">{sub.submittedAt ? new Date(sub.submittedAt).toLocaleDateString('es-EC') : 'N/D'}</span></p>
          </div>
          {sub.observations && Object.keys(sub.observations).length > 0 && (
            <div className="rounded-xl bg-slate-50 p-3 text-sm text-slate-600">
              <p className="font-semibold text-slate-700 mb-1">Observaciones:</p>
              <ul className="list-disc pl-5 space-y-1">
                {Object.entries(sub.observations).map(([questionId, note]) => (
                  <li key={questionId}>
                    <span className="font-semibold">{questionnaire.getAllQuestions().find((q) => q.id === questionId)?.text || questionId}:</span> {note}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {sub.status === 'rejected' && (
            <button
              onClick={() => onEdit(sub)}
              disabled={editingSubmissionId === sub.docId}
              className={`rounded-xl px-4 py-2 text-sm font-semibold bg-[#004AAD] hover:bg-[#003B8A] text-white transition ${editingSubmissionId === sub.docId ? 'opacity-50' : ''}`}
            >
              {editingSubmissionId === sub.docId ? 'En edición' : 'Corregir y reenviar'}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default CompanySubmissionHistory;
